export interface StandaloneZoomToolbarVisibilityInput {
  readonly isEmbedMode: boolean;
  readonly isPositionChart: boolean;
  readonly canWrite: boolean;
  readonly isSavedAtlasView: boolean;
  readonly showUseCaseSelection: boolean;
  readonly showTemplatePicker: boolean;
}

export function shouldShowStandaloneZoomToolbar({
  isEmbedMode,
  isPositionChart,
  canWrite,
  isSavedAtlasView,
  showUseCaseSelection,
  showTemplatePicker,
}: StandaloneZoomToolbarVisibilityInput): boolean {
  if (
    isEmbedMode ||
    isPositionChart ||
    showUseCaseSelection ||
    showTemplatePicker
  ) {
    return false;
  }

  return !canWrite || isSavedAtlasView;
}
